import { resolveImg } from "@/lib/apiData";

export const AuthSideImage = ({ image, text, t, className = "" }) => {
  const lines = (t(text) || "").split(/(?<=[.!?])\s+/).filter(Boolean);
  return (
    <div className={`relative hidden lg:block ${className}`}>
      {image && <img src={resolveImg(image)} alt="" className="absolute inset-0 w-full h-full object-cover" />}
      <div className="absolute inset-0 bg-gradient-to-t from-black via-black/40 to-black/20" />
      <div className="absolute bottom-12 left-12 right-12">
        <h2 className="font-display text-4xl font-black text-white leading-tight" data-testid="auth-side-text">
          {lines.map((l, i) => <span key={i} className={`block ${i === lines.length - 1 && lines.length > 1 ? "text-[#ff5a5a]" : ""}`}>{l}</span>)}
        </h2>
      </div>
    </div>
  );
};
